<template>
  <div class="review-grid-container">
    <Chat />
    <div class="review-title">
      <h2 v-if="moles.length == 1">
        L'imposteur était:
        <span class="colored">{{ moles[0].name }}</span>
      </h2>
      <h2 v-if="moles.length > 1">
        Les imposteurs étaient:
        <span class="colored">{{ molesName }}</span>
      </h2>
      <h2 v-if="moles.length == 0">
        Tout les imposteurs ont étés déconnectés
      </h2>
      <h2>
        Le mot de l'imposteur était:
        <span class="has-text-danger"> {{ reveal_word[0] }} </span>
      </h2>
      <h2>
        L'autre mot était:
        <span class="has-text-primary"> {{ reveal_word[1] }}</span>
      </h2>
      <h2 v-if="mrWhite">
        Mr. White était:
        <span class="colored"> {{ playerById[mrWhiteId].name }}</span>
      </h2>
      <h2 v-if="mrWhiteAnswer != ''">
        Mr White a écrit:
        <span class="colored"> {{ mrWhiteAnswer }}</span>
      </h2>
    </div>
    <div class="review-players">
      <PlayerReview v-for="(player, i) in playerById" :key="i" :playerId="i" />
    </div>
    <div class="review-actions">
      <button
        v-if="wordNb < nbOfWords && isHost"
        class="button is-medium is-link"
        @click="newWord()"
      >
        Nouveau mot
      </button>
      <button
        v-if="wordNb >= nbOfWords && isHost"
        class="button is-medium is-success"
        @click="goToTotal()"
      >
        Aller aux resultats
      </button>
    </div>
  </div>
</template>

<script>
import PlayerReview from "@/components/PlayerReview.vue";
import { mapState, mapGetters } from "vuex";
import Chat from "@/components/Chat.vue";

export default {
  name: "Review",
  components: {
    PlayerReview,
    Chat
  },
  methods: {
    newWord() {
      this.sendMessageToRoom("newWord");
    },
    goToTotal() {
      this.sendMessageToRoom("goToTotal");
    }
  },
  computed: {
    ...mapState("colyseus", [
      "playerById",
      "nbOfWords",
      "wordNb",
      "moleId",
      "innocentId",
      "mrWhiteId",
      "mrWhite",
      "reveal_word",
      "mrWhiteAnswer"
    ]),
    ...mapGetters("colyseus", ["isHost"]),
    moles() {
      let moles = [];
      for (let id of this.moleId) moles.push(this.playerById[id]);
      return moles;
    },
    molesName() {
      return this.moles.reduce((acc, curr) => acc.name + ", " + curr.name);
    },
    commonWord() {
      return this.playerById[this.innocentId].word;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/palette.scss";

.colored {
  color: $intru-5-hex;
}

.review-grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: 0.8fr 1.5fr 0.7fr;
  gap: 1px 1px;
  grid-template-areas: ". review-title review-title ." "review-players review-players review-players review-players" ". review-actions review-actions .";
  align-items: center;
  justify-content: center;
  height: 100%;
  @media only screen and (max-width: 800px) {
    grid-template-columns: 0.1fr 1fr 1fr 0.1fr;
    grid-template-rows: auto 1.5fr auto;
    gap: 10px 1px;
  }
}

.review-title {
  grid-area: review-title;
}

.review-players {
  grid-area: review-players;
  display: flex;
  justify-content: space-around;
  @media only screen and (max-width: 800px) {
    flex-direction: column;
    align-items: center;
  }
}

.review-actions {
  grid-area: review-actions;
}

h2 {
  font-size: 3vmin !important;
  @media only screen and (max-width: 800px) {
    font-size: 5vmin !important;
  }
}
</style>
